module.exports = __webpack_public_path__ + "img/babylon.c99ab5cd.svg";